<div class="top-bar-content" (click)="handleTopBarClicked()">
    <span translate>{{text}}</span>
    <span class="bold" translate>{{boldText}}</span>
    <img src="/assets/img/channels/arrow-right.png">
</div>
